// extracted by mini-css-extract-plugin
export default {"document":"DocumentReview_document__bnEL+","title":"DocumentReview_title__dc+pN","titleContent":"DocumentReview_titleContent__IgpKP","docContent":"DocumentReview_docContent__QSecD"};